import {PureComponent} from 'react'

import ExpandableContent from 'Component/ExpandableContent';
import Link from 'Component/Link';
import Countdown from 'Component/Countdown';

import './BlackFridayTeasingPage.style';

import {EXPIRE_DATE, GUEST_REDIRECT_URL, LOGGED_IN_REDIRECT_URL} from "./BlackFridayTeasingPage.config";
import imageTeasingTimerExpired from '../../../public/assets/images/bf/bf-teasing-expired.png';
import imageTeasingTimerActive from '../../../public/assets/images/bf/bf-teasing.png';

import {isSignedIn} from 'Util/Auth';

class BlackFridayTeasingPage extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            countdownExpired: this.isCountdownExpired()
        }

        this.handleCountdownExpired = this.handleCountdownExpired.bind(this);
    }

    isCountdownExpired() {
        const today = new Date();
        const expireDate = EXPIRE_DATE.replace(/-/g, '/').replace('GMT+0200', 'GMT+0300');

        let diff = (Date.parse(new Date(expireDate)) - Date.parse(new Date(today))) / 1000;

        return diff <= 0;
    }

    handleCountdownExpired() {
        this.setState({countdownExpired: true});
    }

    renderTitle() {
        const {countdownExpired} = this.state;
        return <h1 block="BlackFridayTeasingPage"
                   elem="Title">{countdownExpired ? 'VIP PARTY BLACK FRIDAY A ÎNCEPUT ' : 'AI ACCES ÎNAINTEA TUTUROR LA BLACK FRIDAY '}</h1>
    }

    renderTimer() {
        const {countdownExpired} = this.state;
        if (countdownExpired) return null;

        var today = new Date();

        const timerDate = EXPIRE_DATE;

        return (
            <div block="BlackFridayTeasingPage" elem="Timer">
                <span block="BlackFridayTeasingPage" elem="TimerTitle">AU MAI RĂMAS DOAR</span>
                <Countdown date={timerDate} currentDate={today} onCountdownExpired={this.handleCountdownExpired}/>
                <span block="BlackFridayTeasingPage" elem="TimerText">PÂNĂ LA <strong>BLACK FRIDAY</strong> EXCLUSIV</span>
            </div>
        )
    }

    renderBanner() {
        const {countdownExpired} = this.state;
        const imageTeasing = countdownExpired ? imageTeasingTimerExpired : imageTeasingTimerActive;
        return (
            <div block="BlackFridayTeasingPage" elem="Banner">
                <img src={imageTeasing}/>
            </div>
        )
    }

    renderText() {
        const isLoggedIn = isSignedIn();
        const {countdownExpired} = this.state;

        const buttonLabel = countdownExpired ? (isLoggedIn ? "DESCOPERĂ OFERTA" : "CREEAZĂ-ȚI CONT") : "REZERVĂ-ȚI LOCUL";
        const buttonLink = countdownExpired && isLoggedIn ? LOGGED_IN_REDIRECT_URL : GUEST_REDIRECT_URL;

        const checkSvg = (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                               className="bi bi-check-lg" viewBox="0 0 16 16">
            <path
                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
        </svg>);

        const timerActiveSection = (<div>
            <h3>FII PE LISTA BFF PARTY ÎNAINTEA TUTUROR! </h3>
            <p>Intră în comunitatea celor mai buni prieteni farmec.ro și petrece o zi exclusivă în compania celor mai tari oferte și avantaje Gerovital.</p>
            <ul>
                <li><p><strong>✓</strong> Creează-ți cont pe <strong>farmec.ro</strong></p></li>
                <li><p><strong>✓</strong> Înscrie-te la <strong>Newsletter</strong></p></li>
                <li><p><strong>✓</strong> Pune-ți toate dorințele în <strong>Wishlist</strong></p></li>
            </ul>
          </div>);
        const timerExpiredAndGuestSection = (<div>
            <h3>GĂSEȘTE-ȚI FORMULA BFF EXCLUSIV PÂNĂ LA MIEZUL NOPȚII!</h3>
            <p>Bucură-te de cea mai tare reuniune a avantajelor frumuseții, cu acces special doar pentru membri! Petrece o zi unică alături de cele mai iubite oferte și formule ale noastre, așa cum nu le-a mai văzut nimeni înaintea ta.</p></div>);
        const timerExpiredAndLoggedInSection = (
            <div>
                <h3>GĂSEȘTE-ȚI FORMULA BFF EXCLUSIV PÂNĂ LA MIEZUL NOPȚII!</h3>
                <p>Bucură-te de cea mai tare reuniune a avantajelor frumuseții, cu acces special doar pentru membri! Petrece o zi unică alături de cele mai iubite oferte și formule ale noastre, așa cum nu le-a mai văzut nimeni înaintea ta.</p>
            </div>);

        return (
            <div block="BlackFridayTeasingPage" elem="Text">
                <div block="BlackFridayTeasingPage" elem="TextContent">
                    {countdownExpired && isLoggedIn ? timerExpiredAndLoggedInSection : (!countdownExpired ? timerActiveSection : timerExpiredAndGuestSection)}
                    <Link to={buttonLink} block="Button">{buttonLabel} </Link>
                </div>
            </div>
        )
    }

    renderConditions() {
        const isLoggedIn = isSignedIn();
        const {countdownExpired} = this.state;

        const timerActiveSection = (
            <p>În 9 Noiembrie poți accesa ofertele <strong>VIP Party Black Friday</strong> în exclusivitate, cu o zi înaintea tuturor! Oferta va fi valabilă în limita stocului disponibil și va putea fi accesată exclusiv de către persoanele înregistrate cu cont și abonate la Newsletter. Dacă ai deja cont, asigură-te că ai bifată opțiunea de abonare.</p>);
        const timerExpiredAndGuestSection = (
            <p>Azi, <strong>9 Noiembrie</strong> poți accesa ofertele <strong>VIP Party Black Friday</strong> în exclusivitate, cu o zi înaintea tuturor! Oferta este valabilă în limita stocului disponibil și poate fi accesată exclusiv de către persoanele înregistrate cu cont și abonate la Newsletter. Dacă nu ai cont, creează-ți unul acum!</p>);
        const timerExpiredAndLoggedInSection = (
            <p>Azi, <strong>9 Noiembrie</strong> poți accesa ofertele <strong>VIP Party Black Friday</strong> în exclusivitate, cu o zi înaintea tuturor! Oferta este valabilă în limita stocului disponibil și poate fi accesată exclusiv de către persoanele înregistrate cu cont și abonate la Newsletter.</p>);

        return (
            <div block="BlackFridayTeasingPage" elem="ConditionsWrapper">
                <div block="BlackFridayTeasingPage" elem="Conditions">
                    <ExpandableContent
                        heading='CONDIȚII PROMOȚIE'
                        isContentExpanded
                        mix={{
                            block: 'TeasingPageConditions'
                        }}
                    >
                        {countdownExpired && isLoggedIn ? timerExpiredAndLoggedInSection : (!countdownExpired ? timerActiveSection : timerExpiredAndGuestSection)}
                    </ExpandableContent>
                </div>
            </div>
        );
    }

    renderFaq() {
        const isLoggedIn = isSignedIn();
        const {countdownExpired} = this.state;

        const buttonLabel = countdownExpired ? (isLoggedIn ? "DESCOPERĂ OFERTA" : "CREEAZĂ-ȚI CONT") : "REZERVĂ-ȚI LOCUL";
        const buttonLink = countdownExpired && isLoggedIn ? LOGGED_IN_REDIRECT_URL : GUEST_REDIRECT_URL;

        return (
            <div block="BlackFridayTeasingPage" elem="FAQ">
                <h3>BENEFICIAZĂ DE CELE MAI MARI REDUCERI ALE ANULUI </h3>
                <div block="BlackFridayTeasingPage" elem="FAQItem">
                    <h4>1. Crează-ți Cont și te bucuri de Ofertele Exclusive</h4>
                    <p>Înregistrarea unui cont de membru îți va aduce numeroase avantaje care îmbunătățesc experiența ta de cumpărare și te ajută să te bucuri de o serie de <strong>beneficii exclusive</strong>. </p>
                </div>
                <div block="BlackFridayTeasingPage" elem="FAQItem">
                    <h4>2. Abonează-te la Newsletter</h4>
                    <p>Alege să primești newslettere periodice care conțin informații despre noutăți în lumea cosmeticelor, sfaturi de înfrumusețare, și alte informații utile. Astfel, ești mereu la curent cu cele mai recente tendințe și produse.  </p>
                </div>
                <div block="BlackFridayTeasingPage" elem="FAQItem">
                    <h4>3. Alege-ți Favoritele</h4>
                    <p>Crearea unui Wishlist cu produsele cosmetice favorite este o modalitate rapidă de a-ți organiza și planifica achizițiile în lumea frumuseții. Un produs poate fi adăugat în lista de favorite atunci când ești logat în cont. </p>
                </div>
                <Link to={buttonLink} block="Button">{buttonLabel}</Link>
            </div>
        );
    }

    render() {
        return (
            <div block="BlackFridayTeasingPage">
                <div block="BlackFridayTeasingPage" elem="Container">
                    {this.renderTitle()}
                    {this.renderTimer()}
                    <div block="BlackFridayTeasingPage" elem="Cols">
                        {this.renderBanner()}
                        {this.renderText()}
                    </div>
                    {this.renderConditions()}
                    {this.renderFaq()}
                </div>
            </div>
        )
    }

}

export default BlackFridayTeasingPage;
